<template>
  <div class="animated fadeIn h-100 m-4">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-layers"/> Zones <CButton @click="newZone()" color="info" class="m-0 float-right" size="sm" v-bind="{shape: 'pill'}">New zone</CButton>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover="hover"
              striped="striped"
              bordered="bordered"
              small="small"
              fixed="fixed"
              :items="devices"
              :fields="fields"
              :items-per-page="10"
              pagination
              table-filter
            >
              <template #name="{item}"><td><CLink @click="editZone(item)">{{item.name}}</CLink></td></template>
              <template #parentgroup="{item}"><td>{{item.groupname}}</td></template>
              <template #area="{item}"><td><CBadge v-if="item.area" color="warning" class="mr-1">Area</CBadge></td></template>
              <template #category="{item}"><td><CBadge :color="item.category=='none' ? 'secondary' : 'info'" class="mr-1">{{item.category}}</CBadge></td></template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal title="Edit zone" color="dark" size="lg" :centered="true" :closeOnBackdrop="false" :show.sync="addZoneModal">
      <CRow>
        <CCol sm="9">
          <CInput placeholder="Enter zone name" v-model="zoneName" />
        </CCol>
        <CCol sm="3">
          <ColorPicker v-bind:color.sync="zoneColor" v-model="zoneColor" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="9">
          <CSelect label="Group" :options="groupOptions" :value.sync="zoneGroup" />
        </CCol>
        <CCol sm="3">
          <CInput label="Category" placeholder="Category" v-model="zoneCategory" />
        </CCol>
      </CRow>
      <div><CButton size="sm" @click="addPath()" :disabled="paths.length > 0">Add Path</CButton><CButton size="sm" @click="removePath()" :disabled="paths.length == 0">Remove Path</CButton></div>
      <gmap-map :center="center" :zoom="12" ref="mapa" map-type-id="roadmap" style="width: 100%; height: 100%; min-height: 420px">
        <gmap-polygon v-if="paths.length > 0" :path="paths" :editable="true" @paths_changed="updateEdited($event)"
          @rightclick="handleClickForDelete"
          ref="polygon" v-bind:options="{ strokeColor:'#008000', strokeOpacity: 1.0,
          strokeWeight: 2}">
        </gmap-polygon>
      </gmap-map>
      <template #footer>
        <CButton @click="deleteZone" color="danger" class="mr-auto">Delete zone</CButton>
        <CButton @click="addZoneModal = false" color="secondary ">Cancel</CButton>
        <CButton @click="saveZone" color="success" :disabled="zoneName.length == 0 || paths.length == 0" >Save</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Vue from 'vue'
import { telemetry } from '@/api'
import * as VueGoogleMaps from 'vue2-google-maps'
import ColorPicker from '@/components/ColorPicker.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

export default {
  name: 'Zones',
  components: {
    ColorPicker
  },
  data () {
    return {
      addZoneModal: false,
      devices: [],
      paths: [],
      zoneId: null,
      zoneName: '',
      zoneColor: '',
      zoneGroup: '',
      zoneCategory: 'none',
      edited: null,
      polygonGeojson: '',
      mvcPaths: null,
      polylineGeojson: '',
      errorMessage: null,
      center: {lat: 48.2131007, lng: 17.1751077},
      fields: [{key:'name', label: 'Name'}, {key:'parentgroup', label: 'Group'}, {key:'category', label: 'Category'}]
    }
  },
  computed: {
    groupOptions: function () {
      var options = []
      for(var idx=0; idx < this.$store.state.groups.length; idx++) {
        options.push({ value: this.$store.state.groups[idx].id, label: this.$store.state.groups[idx].name })
      }
      return options
    },
    polygonPaths: function () {
      if (!this.mvcPaths) return
      let paths = [];
      for (let i=0; i < this.mvcPaths.getLength(); i++) {
        let path = [];
        for (let j=0; j<this.mvcPaths.getAt(i).getLength(); j++) {
          let point = this.mvcPaths.getAt(i).getAt(j);
          path.push({lat: point.lat(), lng: point.lng()});
        }
        paths.push(path);
      }
      return paths
    },
  },
  mounted () {
    this.loadZones()
  },
  methods: {
    newZone() {
      this.paths = []
      this.zoneId = null
      this.zoneName = ''
      this.zoneGroup = ''
      this.zoneCategory = 'none'
      this.zoneColor = this.getRandomColor()
      this.addZoneModal = true
    },
    loadZones() {
      telemetry.zones().then(response => {
        if(response.data !== undefined) {
          this.devices = response.data
        }
      }).catch((error) => {
        this.$toasted.error('Unable to access server.')
      })
    },
    openModal() {
      this.$root.$emit('bv::show::modal','modalAddZone')
    },
    deleteZone() {
      let ret = confirm('Are you sure you want to delete ' + this.zoneName + "?")
      if(ret) {
          telemetry.deleteZone(this.zoneId).then(response => {
            this.$toasted.success('Zone deleted.')
            this.addZoneModal = false
            this.loadZones();
          }).catch((error) => {
            this.$toasted.error('Unable to delete zone.')
          })
      }
    },
    updateCenter: function (place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
    },
    updateEdited: function (mvcPaths) {
      this.mvcPaths = mvcPaths
    },
    addPath: function () {
      // obtain the bounds, so we can guess how big the polygon should be
      var bounds = this.$refs.mapa.$mapObject.getBounds()
      var northEast = bounds.getNorthEast()
      var southWest = bounds.getSouthWest()
      var center = bounds.getCenter()
      var degree = this.paths.length + 1;
      var f = Math.pow(0.66, degree)
      // Draw a triangle. Use f to control the size of the triangle.
      // i.e., every time we add a path, we reduce the size of the triangle
      var path = [
        //{ lng: center.lng(), lat: (1-f) * center.lat() + (f) * northEast.lat() },
        { lng: (1-f) * center.lng() + (f) * northEast.lng(), lat: (1-f) * center.lat() + (f) * northEast.lat() },
        { lng: (1-f) * center.lng() + (f) * southWest.lng(), lat: (1-f) * center.lat() + (f) * northEast.lat() },
        { lng: (1-f) * center.lng() + (f) * southWest.lng(), lat: (1-f) * center.lat() + (f) * southWest.lat() },
        { lng: (1-f) * center.lng() + (f) * northEast.lng(), lat: (1-f) * center.lat() + (f) * southWest.lat() }
      ]
      this.paths.push(path)
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    removePath: function () {
      this.paths.splice(this.paths.length - 1, 1)
    },
    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject.getPaths()
          .getAt($event.path)
          .removeAt($event.vertex)
      }
    },
    saveZone() {
      this.updateEdited(this.$refs.polygon.$polygonObject.getPaths());
      telemetry.updateZone({id: this.zoneId, name: this.zoneName, polygon: this.polygonPaths, color: this.zoneColor, category: this.zoneCategory, group: this.zoneGroup })
        .then(response => {
        this.$toasted.success('Zone saved.')
        this.addZoneModal = false
        this.loadZones();
      }).catch((error) => {
        this.$toasted.error('Unable to save zone.')
      })
    },
    editZone(item) {
      this.zoneId = item.id
      this.zoneName = item.name
      this.paths = item.polygon
      this.zoneColor = item.color
      this.addZoneModal = true
      this.zoneCategory = item.category
      this.zoneGroup = item.parentgroup

      var bounds = new google.maps.LatLngBounds();

      for (var idxP = 0; idxP < this.paths.length; idxP++) {
        for (var idxC = 0; idxC < this.paths[idxP].length; idxC++) {
          bounds.extend(this.paths[idxP][idxC])
        }
      }

      this.$refs.mapa.$mapObject.fitBounds(bounds)
      this.$refs.mapa.$mapObject.setZoom(Math.floor(8.9358 - (1.474 * Math.log(Math.max(Math.abs(bounds.getSouthWest().lat() - bounds.getNorthEast().lat()), Math.abs(bounds.getSouthWest().lng() - bounds.getNorthEast().lng()))))))
    },
    readGeojson: function ($event) {
      try {
        this.polygonGeojson = $event.target.value

        var v = JSON.parse($event.target.value);

        this.paths = v.coordinates.map(linearRing =>
          linearRing.slice(0, linearRing.length - 1).map(([lng, lat]) => ({lat, lng}))
        )

        this.errorMessage = null
      } catch (err) {
        this.errorMessage = err.message
      }
    }
  }
}
</script>
